import apiClient from './client';
import type { ImportResult, ImportHistoryItem, PaginatedResponse } from '@/types';

const IMPORT_TIMEOUT = 300000;

export interface ImportStatus {
  batch_id: number;
  filename: string;
  status: string;
  total_rows: number;
  processed_rows: number;
  success_count: number;
  error_count: number;
  result_message: string | null;
  imported_at: string | null;
}

export const importApi = {
  importPayroll: async (file: File): Promise<ImportStatus> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post<ImportStatus>('/import/payroll', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: IMPORT_TIMEOUT,
    });
    return response.data;
  },

  getImportStatus: async (batchId: number): Promise<ImportStatus> => {
    const response = await apiClient.get<ImportStatus>(`/import/status/${batchId}`);
    return response.data;
  },

  importEmployees: async (file: File): Promise<ImportResult> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post<ImportResult>('/import/employees', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: IMPORT_TIMEOUT,
    });
    return response.data;
  },

  getImportHistory: async (page = 1, pageSize = 10): Promise<PaginatedResponse<ImportHistoryItem>> => {
    const response = await apiClient.get<PaginatedResponse<ImportHistoryItem>>('/import/history', {
      params: { page, page_size: pageSize },
    });
    return response.data;
  },
};
